import React, {useEffect, useState} from 'react';
import {GET} from "../../../utils/lib/axios";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import BabySitterCard from "../components/BabySitterCard";
import MeetingRoomCard from "../components/MeetingRoomCard";
import useAuth from "../../../utils/hooks/useAuth";

const MeetingRoom = () => {
    const [meetingRooms, setMeetingRooms] = useState<Record<string, any>[]>([]);
    const {user} = useAuth()

    const loadBabySitters = () => {
        GET({path: "/hotels/{id}/meetingRooms"}, {id: user?.hotel?.id}).then(r => {
            setMeetingRooms(r.data)
        }).catch(e => toast.error(e.response.data.message));
    }
    useEffect(() => {
        loadBabySitters()
    }, [])
    return (

        <div className="p-5 grid grid-cols-3 grid-rows-2 h-full gap-5 ">
            {meetingRooms.map((meetingRomm, i) =>
                <Link to={`./${meetingRomm.id}`}
                      className={``}>
                    <MeetingRoomCard  item={meetingRomm}
                    />

                </Link>
            )}


        </div>

    );
};

export default MeetingRoom;
